import { CommonModule, registerLocaleData } from '@angular/common';
import localeNL from '@angular/common/locales/nl';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';

import { ApAnalyticsModule, FALLBACK_PAGENAME } from '@ap/analytics';
import { ApContentModule } from '@ap/content';
import { ApErrorModule } from '@ap/error';
import { ApHeaderComponent } from '@ap/header';
import { ApAuthenticatieFidoModule } from '@ap/interface-apic-authenticatie-fido';
import { SessiebeheerModule } from '@ap/interface-apic-sessiebeheer';
import { TokenbeheerModule } from '@ap/interface-apic-tokenbeheer';
import { MijnLoginTemplateModule } from '@ap/mijn-template';
import { ApModalComponent } from '@ap/modal';
import { ApNotificationComponent } from '@ap/notification';
import { ApPersistenceModule } from '@ap/persistence';
import { ApSignComponent } from '@ap/sign';
import { ErrorModule } from '@ap/tokens-browser';

import { DeviceWrapperComponent } from './device/device.wrapper.component';
import { DeviceWrapperModule } from './device/device.wrapper.module';
import { DeviceGuard } from './device/guard/device.guard';
import { FinishedWrapperComponent } from './finished/finished.wrapper.component';
import { FinishedWrapperModule } from './finished/finished.wrapper.module';
import { MijnTokensBrowserComponent } from './mijn-tokens-browser.component';
import { MijnTokensBrowserNavigation } from './mijn-tokens-browser.navigation';
import { NameGuard } from './name/guard/name.guard';
import { NameWrapperComponent } from './name/name.wrapper.component';
import { NameWrapperModule } from './name/name.wrapper.module';
import { PincodeWrapperComponent } from './pincode/pincode.wrapper.component';
import { PincodeWrapperModule } from './pincode/pincode.wrapper.module';
import { StartWrapperComponent } from './start/start.wrapper.component';
import { StartWrapperModule } from './start/start.wrapper.module';
import { VerifyPincodeGuard } from './verify-pincode/guard/verify-pincode.guard';
import { VerifyPincodeWrapperComponent } from './verify-pincode/verify-pincode.wrapper.component';
import { VerifyPincodeWrapperModule } from './verify-pincode/verify-pincode.wrapper.module';

/**
 * @name MijnTokensBrowserModule
 * @ngdoc module
 */
@NgModule({
    declarations: [MijnTokensBrowserComponent],
    exports: [MijnTokensBrowserComponent],
    bootstrap: [MijnTokensBrowserComponent],
    imports: [
        ApAnalyticsModule,
        ApAuthenticatieFidoModule,
        ApErrorModule,
        ApSignComponent,
        BrowserAnimationsModule,
        BrowserModule,
        CommonModule,
        ApContentModule,
        DeviceWrapperModule,
        ErrorModule,
        FinishedWrapperModule,
        ApHeaderComponent,
        MijnLoginTemplateModule,
        ApModalComponent,
        NameWrapperModule,
        ApNotificationComponent,
        ApPersistenceModule,
        PincodeWrapperModule,
        RouterModule.forRoot(MijnTokensBrowserModule.routes, { useHash: true }),
        SessiebeheerModule,
        StartWrapperModule,
        TokenbeheerModule,
        VerifyPincodeWrapperModule
    ],
    providers: [
        {
            provide: FALLBACK_PAGENAME,
            useValue: ''
        }
    ]
})
export class MijnTokensBrowserModule {
    public static readonly routes: Routes = [
        {
            path: MijnTokensBrowserNavigation.START,
            pathMatch: 'full',
            component: StartWrapperComponent
        },
        {
            path: MijnTokensBrowserNavigation.PINCODE,
            component: PincodeWrapperComponent
        },
        {
            path: MijnTokensBrowserNavigation.VERIFY_PINCODE,
            component: VerifyPincodeWrapperComponent,
            canActivate: [VerifyPincodeGuard]
        },
        {
            path: MijnTokensBrowserNavigation.NAME,
            component: NameWrapperComponent,
            canActivate: [NameGuard]
        },
        {
            path: MijnTokensBrowserNavigation.DEVICE,
            component: DeviceWrapperComponent,
            canActivate: [DeviceGuard]
        },
        {
            path: MijnTokensBrowserNavigation.FINISHED,
            component: FinishedWrapperComponent
        },
        {
            path: '**',
            redirectTo: MijnTokensBrowserNavigation.START
        }
    ];

    public constructor() {
        registerLocaleData(localeNL, 'nl');
    }
}
